<template>
  <div class="base">
    <div class="footer-info">
      <div class="left">
        <div class="left-top">
          <router-link to="/society"><a>社会责任</a></router-link>
          |
          <router-link to="/eden"><a>瑞普乐园</a></router-link>
        </div>
        <div class="web">
          <span>版权所有：杭州瑞普视听工程有限公司COPYRIGHT 2012-2013 <a href="https://beian.miit.gov.cn">浙ICP备10048267号-1</a> 网站统计</span>
        </div>
      </div>
      <div class="right">
            <p>服务热线：<strong>400-0571-819</strong></p>
            <p>公司地址：杭州市拱墅区石祥路59号新华经济园35号楼</p>
            <p>站长信箱：postmaster@ripeav.com</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RlFooter"
}
</script>

<style lang="less" scoped>
.base{
  font-size: 14px;
  background: #131D35;
  padding: 60px 0 60px 0;
  .footer-info{
    width: 80%;
    height: 100%;
    margin: 0 auto;
    display: flex;
    position: relative;
    justify-content: space-between;
    .left{
      color: whitesmoke;
      .left-top{
        padding-bottom: 20px;
        a{
          color: whitesmoke;
          text-decoration: none;
          padding: 0 20px;
          font-size: 16px;
          &:first-child{
            padding-left: 0;
          }
        }
      }
    }
    .web{
      span{
        font-size: 12px;
        opacity: 0.75;
        a{
          color: whitesmoke;

        }
      }
    }
    .right{
      width: 42%;
      text-align: right;
      color: whitesmoke;
      p{
        /*float: right;*/
        line-height: 28px;
        font-size: 12px;
        &:first-child{
          font-size: 20px;
        }
      }
    }

  }
}

</style>